import React from 'react';
import Details from './Details';
import Avatar from './Avatar';
import styles from './ContactCard.module.css';
import { motion } from 'framer-motion';

const ContactCard = (props) => {
  return (
    <motion.div animate={{ y: -100 }} className={styles.contact_card}>
      <div className={styles.card}>
        <div className={styles.emailcard}>
          <div className={styles.top}>
            <h2 className={styles.name}>{props.name}</h2>
            <Avatar image={props.image} />
          </div>
          <div className={styles.bottom}>
            <Details detailInfo={props.address} />
            <Details detailInfo={props.tel} />
            <Details detailInfo={props.email} />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ContactCard;
